import React from 'react'
import { useSelector } from 'hooks'
import { T, CriteriaSelect } from 'components'
import { StyledBlock } from './StyledMyProfile'

const Block = ({ children, label, name, className = '', hidden }) => {
  const textOnly = /string|number/.test(typeof children)

  return (
    <StyledBlock textOnly={textOnly} className={`block ${className} ${hidden ? 'hidden' : ''}`}>
      <div className="name">{label ? <T label={`${label}|noColon`} /> : name?.replace(/<!--.*?-->/, '')}</div>
      <div className="value">{children}</div>
    </StyledBlock>
  )
}

export const CriteriaBlock = ({ id, multiSelect, empty, person = 1, disabled, notOwnProfile, user }) => {
  const profile = user || useSelector(s => s.myProfile)
  const selected = profile[`criteriaPerson${person}`]?.[id]
  const criteria = useSelector(s => s.registry.criteria)
  const name = criteria.find(e => e.id === id)?.name

  return (
    <Block name={name} key={id} hidden={notOwnProfile && !selected}>
      <CriteriaSelect id={id} group={'criteriaPerson' + person} {...{ selected, multiSelect, empty, disabled }} />
    </Block>
  )
}

export default Block
